module.exports = "/_next/static/images/Belanja_di_Toko_Website-Banner-ab047e60c58c58112792c6b2eee62eba.jpg";